import { render, staticRenderFns } from "./profiles.vue?vue&type=template&id=3da99187&scoped=true"
import script from "./profiles.vue?vue&type=script&lang=js"
export * from "./profiles.vue?vue&type=script&lang=js"
import style0 from "./profiles.vue?vue&type=style&index=0&id=3da99187&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da99187",
  null
  
)

export default component.exports